<template>

  <div>

    <div class="ui large breadcrumb">
      <div class="bold section">{{ title }}</div>
    </div>

    <bookmark-button :label="title" />

    <div class="ui divider"></div>

    <div class="ui grid">      
      <div class="eleven wide computer sixteen wide tablet sixteen wide mobile column">
        <button class="ui blue button" @click="$refs.formModal.create()">
          <i class="plus icon"></i> Novo Modelo
        </button>
      </div>
      <div class="five wide computer sixteen wide tablet sixteen wide mobile column">
        <div class="ui basic right aligned segment no-padding no-margin">
          <div class="ui form">
            <div class="field">
              <search-input id="cert-templates-search-input" ref="searchInput" @onSearch="search" />
            </div>
          </div>    
        </div> 
      </div>
    </div>

    <data-table id="cert-templates-dtbl" ref="dtbl" :service="service" :attributes="attributes" :fields="fields" @onRowClick="onUpdate" />

    <form-modal ref="formModal" @onSave="refresh" @onRemove="refresh" />

  </div>

</template>

<script>
  
  import CertTemplateService from "@/services/cert-template-service"
  import FormModal from "./form-modal"
  import { gridPage, onlySimavet } from "@/mixins"

  export default {    

    name: "CertTemplatesPage",

    mixins: [gridPage, onlySimavet],

    data() {
      return {        
        title: "Modelos de Laudos",
        service: new CertTemplateService(),
        attributes: ["id", "name", "title", "comments", "commentsContents"],
        fields: [          
          { prop: "name", label: "Nome do Modelo" },
          { prop: "title", label: "Título para Impressão" },
          { prop: "organs", label: "Órgãos", render: this.renderOrgans, sortDisabled: true },
        ],
      }
    },

    components: {
      FormModal,
    },

    methods: {

      renderOrgans(template) {

        let labels = ""

        labels += `<div class="ui small labels">`

        for (let organ of template.organs) {
          labels += `<div class="ui label">${organ.organ.description}</div>`
        }

        labels += `</div>`

        return labels
      },

      onUpdate(data) {
        this.$refs.formModal.update(data.row)
      }
    },
  }

</script>
